import './skeleton-branches.scss';
import Skeleton from '@mui/material/Skeleton';

export const SkeletonBranches = () => {

    return (
        <div className='skeleton-branch'>
            <Skeleton variant="text" width={300} height={40}/>
            <Skeleton variant="text" width={250} height={40}/>
            <br /><br /><br />
            <Skeleton variant="text" width={200} height={40}/>
            <Skeleton variant="text" width={500} height={60}/>
        </div>
    );
}